import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSlider = () => {
  return (
    <g>
      <path d="M7.23 4c1.377 0 2.591.694 3.312 1.75h3.205A2.252 2.252 0 0 1 16 8c0 1.19-.927 2.166-2.099 2.245l-.154.005h-3.205A4.003 4.003 0 0 1 7.23 12a4.003 4.003 0 0 1-3.312-1.75H2.253A2.252 2.252 0 0 1 .005 8.154L0 8c0-1.19.927-2.166 2.099-2.245l.154-.005h1.664A4.003 4.003 0 0 1 7.23 4zm0 1.5A2.502 2.502 0 0 0 4.726 8c0 1.38 1.121 2.5 2.504 2.5A2.502 2.502 0 0 0 9.733 8c0-1.38-1.12-2.5-2.503-2.5zm3.935 1.75a4.016 4.016 0 0 1 0 1.5h2.582a.75.75 0 0 0 .744-.648L14.498 8a.75.75 0 0 0-.65-.743l-.101-.007h-2.582zM3.224 8c0-.256.024-.507.07-.75h-1.04a.75.75 0 0 0-.745.648L1.502 8c0 .38.283.693.65.743l.101.007h1.041a4.016 4.016 0 0 1-.07-.75z" />
    </g>
  );
};

export default withIcon(IconSlider);
